
import type { SVGProps } from 'react';
const SvgBed = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <g clipPath="url(#bed_svg__a)">
      <path
        fill="#263E6A"
        d="M19.711 12.41h-1.394V8.762A.76.76 0 0 0 17.555 8H6.465c-.43 0-.78.35-.78.78v3.63H4.289A.29.29 0 0 0 4 12.7v5.409a.277.277 0 0 0 .554 0v-.886q.019.004.038.004H17.29a.277.277 0 0 0 0-.554H4.592q-.019 0-.038.004v-1.444q.019.004.038.004h9.15a.277.277 0 0 0 0-.554h-9.15q-.019 0-.038.004v-1.723h14.892v5.145a.277.277 0 0 0 .554 0v-5.41c0-.16-.13-.288-.289-.288M6.24 8.78c0-.124.102-.226.227-.226h11.09c.114 0 .207.093.207.207v3.65h-1.054v-1.838a.873.873 0 0 0-.872-.872H13.34a.873.873 0 0 0-.872.872v1.838h-.978v-1.838a.873.873 0 0 0-.872-.872H8.123a.873.873 0 0 0-.872.872v1.838H6.239zm9.916 3.63h-3.132v-1.837c0-.175.143-.318.318-.318h2.496c.175 0 .318.143.318.318zm-5.218 0H7.805v-1.837c0-.175.142-.318.318-.318h2.496c.175 0 .318.143.318.318z"
      />
    </g>
    <defs>
      <clipPath id="bed_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgBed;
